import "./BodhiTile.css";

const BodhiTile = ({
	label,
	sub,
	tag,
	icon,
	color = "#6B9E8D",
	active = false,
	size = "default",
	className = "",
	style,
	...rest
}) => {
	const cls = [
		"bodhi-tile",
		size === "sm" && "bodhi-tile-sm",
		size === "rail" && "bodhi-tile-rail",
		active && "bodhi-tile-active",
		className,
	]
		.filter(Boolean)
		.join(" ");

	return (
		<div
			className={cls}
			style={{ "--bodhi-tile-color": color, ...style }}
			{...rest}
		>
			{icon && <span className="bodhi-tile-icon">{icon}</span>}
			<div className="bodhi-tile-body">
				{tag && (
					<div className="bodhi-tile-tag">
						<span className="bodhi-tile-dot" />
						{tag}
					</div>
				)}
				<div className="bodhi-tile-label">{label}</div>
				{sub && <div className="bodhi-tile-sub">{sub}</div>}
			</div>
		</div>
	);
};

export default BodhiTile;
